export enum ESportsApiV1 {
  FOOTBALL = 'Futbol',
  BASKETBALL = 'Basket',
  BASEBALL = 'Beisbol',
  VOLLEYBALL = 'Voleibol',
  HOCKEY = 'Hockey',
  HANDBALL = 'Balonmano',
  AMERICAN_FOOTBALL = 'FutbolAmericano',
  TENNIS = 'Tenis',

  GANADAZO = 'Ganadazo',
  TORITO = 'Torito',
  MEGAMILLIONS = 'Megamillions',
}

export enum ESportsRoutes {
  FOOTBALL = 'Futbol',
  BASKETBALL = 'Baloncesto', // Basket
  BASEBALL = 'Beisbol',
  VOLLEYBALL = 'Voleibol',
  HOCKEY = 'Hockey',
  HANDBALL = 'Balonmano',
  AMERICAN_FOOTBALL = 'Futbol-Americano',
  TENNIS = 'Tenis', // Tenis
  GANADAZO = 'Ganadazo',
  TORITO = 'Torito',
  MEGAMILLIONS = 'Megamillions',
}

export enum ESportsRoutesEN {
  FOOTBALL = 'Football',
  BASKETBALL = 'Basketball', // Basket
  BASEBALL = 'Baseball',
  VOLLEYBALL = 'Volleyball',
  HOCKEY = 'Hockey',
  HANDBALL = 'Handball',
  AMERICAN_FOOTBALL = 'American-Football',
  TENNIS = 'Tennis', // Tenis
  GANADAZO = 'Ganadazo',
  TORITO = 'Torito',
  MEGAMILLIONS = 'Megamillions',
}

// export type SportType =
//   | 'Futbol'
//   | 'Basket'
//   | 'Beisbol'
//   | 'Voleibol'
//   | 'Hockey'
//   | 'Balonmano'
//   | 'FutbolAmericano'
//   | 'Tenis'
//   | 'Ganadazo'
//   | 'Torito'
//   | 'Megamillions';

export type I18nSportType =
  | 'Football'
  | 'Basket'
  | 'Baseball'
  | 'Volleyball'
  | 'Hockey'
  | 'HandBall'
  | 'AmericanFootball'
  | 'Ganadazo'
  | 'Tennis';

export interface SportsModel {
  sport: ESportsApiV1;
  text: string;
  selected: boolean;
  route: string;
  icon: string;
  active: boolean;
  tracker: string;
  urlIcon: string;
}

interface TeamModel {
  idTeam: string;
  score: number | null;
  name: string;
  winner_price: number;
  handicap_market: string;
  handicap_block: number;
  market_total: string;
  block_total: number;
}

export interface OddsModel {
  idOdds: string;
  active: boolean;
  isLive: boolean;
  eventDate: string;
  championshipsName: string;
  country: string;
  homeTeam: string;
  awayTeam: string;
  one: any;
  two: any;
  x: any;
  details: any;
}

export interface GroupedResult {
  championshipName: string;
  country: string;
  active: boolean;
  results: any[];
}
